"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = require("react");
var _feature = require("@studio/feature.flags");
var useLaunchDarkly = function useLaunchDarkly(user, ldKey) {
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    isLDInitializedOrTimedOut = _useState2[0],
    setLDIsInitializedOrTimedOut = _useState2[1];
  (0, _react.useEffect)(function () {
    var timeoutId;
    if (user && ldKey && !isLDInitializedOrTimedOut) {
      (0, _feature.initializeLaunchDarkly)(user, ldKey).then(function () {
        return setLDIsInitializedOrTimedOut(true);
      });
      timeoutId = setTimeout(function () {
        return setLDIsInitializedOrTimedOut(true);
      }, 2000);
    }
    return function () {
      return clearTimeout(timeoutId);
    };
  }, [user, ldKey]);
  return isLDInitializedOrTimedOut;
};
var _default = exports["default"] = useLaunchDarkly;